<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <report-promo-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="getData"
      :loading="loading"
    />

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      item-key="id"
      sort-by="id"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportItemParent="exportItem"
        />
      </template>
      <template v-slot:item="{ item, index }">
        <report-promo-item
          :options="options"
          :selectedRow="selectedRow"
          :item="item"
          :index="index"
          v-on:selectRowParent="selectRow"
        />
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { date, showAlert } from '../../lib/helpers';

export default {
  components: {
    ReportPromoItem: () => import('../../components/table/ReportPromoItem.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    ReportPromoFilter: () =>
      import('../../components/table/ReportPromoFilter.vue'),
  },

  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    options: {},
    view: false,
    filter: {
      trx_date: [],
    },
    dialog: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Nama Promo',
        value: 'promo_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Merchant PAN',
        value: 'mpan',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Reff ID',
        value: 'rrn',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Customer PAN',
        value: 'customer_pan',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Customer Name',
        value: 'customer_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Amount',
        value: 'amount',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Discount',
        value: 'discount',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Cashback',
        value: 'cashback',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Transaction Date',
        value: 'trx_date',
        width: '150',
        align: 'center',
        sortable: false,
      },
    ],
    search: {
      promo_name: '',
      mid_bank: '',
      mpan: '',
      rrn: '',
      customer_pan: '',
      trx_date: [],
    },
    editedItem: {},
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.reportPromo.allData;
    },
    detailData() {
      return this.$store.state.reportPromo.item;
    },
    totalData() {
      return this.$store.state.reportPromo.totalData;
    },
    totalPage() {
      return this.$store.state.reportPromo.totalPage;
    },
    loading() {
      return this.$store.state.reportPromo.loading;
    },

    flashError: {
      get() {
        return this.$store.state.reportPromo.flashError;
      },
      set() {
        this.$store.commit('reportPromo/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.reportPromo.flashErrorMessage;
    },
    allowSearch() {
      return (
        this.search.promo_name != '' ||
        this.search.mid_bank != '' ||
        this.search.mpan != '' ||
        this.search.rrn != '' ||
        this.search.customer_pan != '' ||
        this.search.trx_date.length > 0
      );
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('reportPromo/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      if (!this.allowSearch) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'filter harus diisi !', 'mdi-alert', 'red');
      } else {
        this.$store.commit('reportPromo/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('reportPromo/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    closeFlash() {
      this.$store.commit('reportPromo/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.promo_name = '';
      this.search.mid_bank = '';
      this.search.mpan = '';
      this.search.rrn = '';
      this.search.customer_pan = '';
      this.search.trx_date = [];
    },

    exportItem() {
      if (!this.allowSearch) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'filter harus diisi !', 'mdi-alert', 'red');
      } else if (this.totalData <= 0) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'No data exported !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('reportPromo/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
